// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_embla-carousel_esm_embla-carousel_esm_js","src_js-new_components_bottom-navbar_js-src_js-new_components_categories-filter_js-src_js-new_-d994a9"], () => (__webpack_require__("./src/js-new/main.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
